import React from 'react'
import {withToggles,fetchConnect} from 'startlibs/lib/hocs'
import {Link, Dialog, Button, Icon} from 'startlibs/lib/components'
import {getWorkstations} from '../selectors'
import {unlinkAllWorkstations, unlinkWorkstation, loadWorkstations} from '../reducers'
import {en_US,formatDate} from 'report-components'

@fetchConnect((state)=>({workstations:getWorkstations(state)}),{unlinkWorkstation,unlinkAllWorkstations,connectFetcher:loadWorkstations})
@withToggles("unlinkAllDialog","unlinkedAllDialog","unlinkedOneDialog", "isLoading")
export class Workstations extends React.PureComponent {

  unlinkAll = () => {
    this.props.isLoading.open()
    this.props.unlinkAllWorkstations()
      .then(this.props.unlinkAllDialog.close)
      .then(this.props.isLoading.close)
      .then(this.props.unlinkedAllDialog.open)
  }

  componentDidUpdate(oldProps) {
    if (this.props.workstations.length < oldProps.workstations.length && !this.props.unlinkedAllDialog.isOpen && !this.props.unlinkAllDialog.isOpen) {
      const removed = oldProps.workstations.filter(_=>this.props.workstations.indexOf(_)<0)
      this.props.unlinkedOneDialog.open(removed.map(_=>_.stationName)[0])
    }
  }

  render() {
    const {workstations,unlinkAllDialog, unlinkedAllDialog,unlinkWorkstation,unlinkedOneDialog, isLoading} = this.props
    return (
      <div className="content edit-profile workstations">
      <div><Button.Link className="return-home-button" icon="arrow-left" to="/">Home</Button.Link></div>
      <div className="profile-header">
          <h1>Horos workstations</h1>
          <div className="profile-menu">
              <Link className="button nav-tab" to="/profile">Profile</Link>
              <Link className="button nav-tab" skipTo="/account-settings">Settings</Link>
              <Link className="button nav-tab active" to="/workstations">Manage workstations</Link>
          </div>
      </div>
        {
          workstations.length===0 &&
          <div className="no-results-message horos-download-message">
            <h2>No workstations linked to your Horos Cloud</h2>
            <p>To link a workstation to your Horos Cloud account, open Horos app on your computer, click the "Cloud Report" icon and sign in.</p>

            <Button.a highlight href="horos://" className="horos-download-button">Launch Horos</Button.a>

            <p>Do not have Horos App installed yet? <a className="link" href="https://horosproject.org/download-horos/" target="_blank" >Download here</a>.</p>
          </div>
        }
        <div className="card-list">
          {
            workstations.map(workstation=> <WorkstationCard key={workstation.id} confirmUnlink={unlinkWorkstation} workstation={workstation} />)
          }
        </div>
        {
          workstations.length!==0 &&
          <div className="profile-footer">
              <Button onClick={unlinkAllDialog.open}>Unlink all workstations</Button>
          </div>
        }
        {
          unlinkAllDialog.isOpen &&
          <Dialog
            closeDialog={unlinkAllDialog.close}
            title="Confirm unlink"
          >
            <Dialog.Content>
            <p>You are about to unlink your Horos Cloud account for all of your workstations.</p>
            <p>By unlinking the workstations you will need to login again on your next access on
            each workstation. <b>Would you like to confirm?</b></p>
            </Dialog.Content>
            <Dialog.Footer>
              <Button onClick={unlinkAllDialog.close}>Cancel</Button>
              <Button alert isLoading={isLoading.isOpen} onClick={this.unlinkAll}>Confirm unlink</Button>
            </Dialog.Footer>
          </Dialog>
        }
        {
          unlinkedAllDialog.isOpen &&
          <Dialog
            closeDialog={unlinkedAllDialog.close}
            title="Workstations unlinked successfully"
          >
            <Dialog.Content>
              <p>All workstations associated with this account have been successfully unlinked.
                For future sessions on these workstations users will be requested to login in order
                to properly use Horos Cloud.</p>
            </Dialog.Content>
            <Dialog.Footer>
              <Button onClick={unlinkedAllDialog.close}>Close</Button>
            </Dialog.Footer>
          </Dialog>
        }
        {
          unlinkedOneDialog.isOpen &&
          <Dialog
            closeDialog={unlinkedOneDialog.close}
            title="Workstation unlinked successfully"
          >
            <Dialog.Content>
              <p>{unlinkedOneDialog.isOpen} has been successfully unlinked.
                For future sessions on that workstation users will be requested to login in order
                to properly use Horos Cloud.</p>
            </Dialog.Content>
            <Dialog.Footer>
              <Button onClick={unlinkedOneDialog.close}>Close</Button>
            </Dialog.Footer>
          </Dialog>
        }
      </div>
    )
  }
}

const CardContent = ({workstation,children})=><div>
  <div className="card-content">
    {children}
    <div className="card-title">{workstation.stationName}</div>
    <div className="card-detail">
      <div>Latest access in:</div>
      <div>{formatDate(new Date(workstation.creationTimestamp),en_US,"L dd, yyyy")}</div>
    </div>
  </div>
</div>

@withToggles("unlinkDialog","isLoading")
class WorkstationCard extends React.PureComponent {

  confirmUnlink = () => {
    this.props.isLoading.open()
    this.props.confirmUnlink(this.props.workstation.id)
      .then(this.props.isLoading.close)
  }

  render() {
    const {workstation,unlinkDialog, isLoading} = this.props

    return (
      <div className="card with-icon">
        <CardContent workstation={workstation}>
          <div className="buttons-container">
            <Button small onClick={unlinkDialog.open}>Unlink</Button>
            <div className="card-icon"><Icon icon="station"/></div>
          </div>
        </CardContent>

        {
          unlinkDialog.isOpen &&
          <Dialog
            title="Confirm unlink"
            closeDialog={unlinkDialog.close}
          >
            <Dialog.Content>
              <p>You are about to unlink your Horos Cloud account for the following workstation:</p>
              <div className="box-list">
                <div className="box with-icon">
                  <CardContent workstation={workstation}>
                    <div className="card-icon"><Icon icon="station"/></div>
                  </CardContent>
                </div>
              </div>
              <p>By unlinking this workstation you will need to login again on your next access on
              that workstation. <b>Would you like to confirm?</b></p>
            </Dialog.Content>
            <Dialog.Footer>
              <Button onClick={unlinkDialog.close}>Cancel</Button>
              <Button alert isLoading={isLoading.isOpen} onClick={this.confirmUnlink}>Confirm unlink</Button>
            </Dialog.Footer>
          </Dialog>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/workstations/Workstations.jsx